import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UpdateVidyoParticipantDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const removeParticipant = async ({
  sessionId,
  body,
}: {
  sessionId: string;
  body: UpdateVidyoParticipantDto;
}): Promise<void> => {
  await axiosClient.post<void, UpdateVidyoParticipantDto>(
    `sessions/${sessionId}/in-call/remove-participant`,
    body,
  );
};

function useRemoveParticipant(
  mutationOptions?: UseMutationOptions<
    void,
    HttpError,
    { sessionId: string; body: UpdateVidyoParticipantDto }
  >,
) {
  return useMutation({
    mutationFn: removeParticipant,
    ...mutationOptions,
  });
}

export { useRemoveParticipant };
